import React from 'react';
import PropTypes from 'prop-types';

const SvgCurved = ({ active, ...props }) => {
    const strokeColor = active ? '#ffffff' : '#343A72';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="9" fill="none" viewBox="0 0 23 9" {...props}>
            <path
                stroke={strokeColor}
                strokeLinecap="round"
                strokeWidth="1.25"
                d="M1 4.16C5.267 4.16 5.38 1 7.626 1c3.369 0 5.165 6.885 7.187 6.998C16.834 8.11 17.508 4.273 22 4.16"
            />
        </svg>
    );
};
SvgCurved.propTypes = {
    active: PropTypes.bool,
};
SvgCurved.defaultProps = {
    active: false,
};

export default SvgCurved;
